var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.128408 5.87145C0.214148 5.95719 0.299823 6 0.428442 6C0.556991 6 0.64273 5.95713 0.728476 5.87145L2.99993 3.6L5.27138 5.87145C5.35712 5.95719 5.48567 6 5.57142 6C5.65716 6 5.78571 5.95713 5.87145 5.87145C6.04287 5.70004 6.04287 5.44288 5.87145 5.27146L3.6 3.00001L5.87145 0.728553C6.04287 0.557137 6.04287 0.299977 5.87145 0.128561C5.70004 -0.0428538 5.44287 -0.0428538 5.27146 0.128561L3.00001 2.40002L0.728553 0.128561C0.557137 -0.0428538 0.299977 -0.0428538 0.128561 0.128561C-0.0428538 0.299977 -0.0428538 0.557137 0.128561 0.728553L2.40001 3.00001L0.128561 5.27146C-0.0428538 5.44294 -0.0428538 5.70004 0.128561 5.87151L0.128408 5.87145Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallX);
export default __webpack_public_path__ + "static/media/SmallX.ee3da53e06b007c37b1492423692fd65.svg";
export { ForwardRef as ReactComponent };